exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-7aacb924]{font-family:var(--font-family-primary);line-height:1.6}\n", ""]);

// exports
